import React from 'react';
import { RouteComponentProps } from 'react-router';

import { Loading } from '../Spinner/LoadingHOC';
import PageTitle from '../PageTitle';
import { DocumentUpload } from './Presentational';
import SessionManager from '../../../util/sessionManager';

const LiftedDocumentUpload: React.FunctionComponent<RouteComponentProps> = props => {
  const token = SessionManager.token;
  const payload = token ? JSON.parse(atob(token.split('.')[1])) : null;
  const customerUUID = payload?.customerUUID || '';

  return (
    <Loading loading={false}>
      <PageTitle pageTitle="Secure Document Upload" />
      <DocumentUpload {...props} customerUUID={customerUUID} />
    </Loading>
  );
};

export default LiftedDocumentUpload;
